var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{class:_vm.svgClass,attrs:{"aria-hidden":"true"},on:{"click":function($event){$event.stopPropagation();$event.preventDefault();return _vm.$emit('ok')}}},[_c('use',{attrs:{"xlink:href":_vm.iconName}}),(!!_vm.title)?_c('title',[_vm._v(_vm._s(_vm.title))]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }